import React, { useState } from 'react';
import { useInView } from './useParallax';
import { ArunachalaMap, LANDMARKS } from './JourneySVGs';
import './JourneySection.css';

export default function JourneySection() {
  const [ref, inView]           = useInView(0.06);
  const [hoverId, setHoverId]   = useState(null);
  const [selected, setSelected] = useState(null);

  const activeLm = selected || LANDMARKS.find(l => l.id === hoverId);

  return (
    <section className="jny" id="journey" ref={ref}>
      <div className="jny__inner">

        {/* ── Map — takes up most of the width ── */}
        <div className={`jny__map-col ${inView ? 'jny__map-col--in' : ''}`}>
          <ArunachalaMap
            activeId={hoverId}
            onHover={setHoverId}
            onClick={lm => setSelected(prev => prev?.id === lm.id ? null : lm)}
            className="jny__map-svg"
          />
        </div>

        {/* ── Info panel ── */}
        <div className={`jny__info ${inView ? 'jny__info--in' : ''}`}>
          <p className="jny__eyebrow cinzel">Tiruvannamalai</p>
          <h2 className="jny__title cinzel">
            Girivalam<br />
            <span className="jny__accent">Pradakshina</span>
          </h2>

          <p className="jny__desc">
            The sacred 14 km barefoot circumambulation of Arunachala. Eight Ashta
            Lingams mark the eight directions. Vedanagari Ashram lies 18 km north
            of the circuit on the Vellore Highway.
          </p>

          {/* Tooltip */}
          <div className={`jny__tooltip ${activeLm ? 'jny__tooltip--show' : ''}`}>
            {activeLm ? (
              <>
                <div
                  className="jny__tooltip-bar"
                  style={{ background: activeLm.color }}
                />
                <div className="jny__tooltip-body">
                  <p className="jny__tooltip-sub cinzel">{activeLm.subtitle}</p>
                  <p className="jny__tooltip-name cinzel">{activeLm.title}</p>
                  {activeLm.direction && (
                    <span
                      className="jny__tooltip-badge cinzel"
                      style={{ borderColor: activeLm.color, color: activeLm.color }}
                    >
                      {activeLm.direction} · {activeLm.isLandmark ? 'Landmark' : 'Ashta Lingam'}
                    </span>
                  )}
                </div>
              </>
            ) : (
              <p className="jny__tooltip-idle cinzel">Hover a marker to explore</p>
            )}
          </div>

          <div className="jny__legend">
            <span className="jny__legend-dot" style={{ background: '#FF6B00' }} />Ashta Lingam&nbsp;&nbsp;
            <span className="jny__legend-dot" style={{ background: '#C9902A' }} />Landmark&nbsp;&nbsp;
            <span className="jny__legend-dot" style={{ background: '#F5C842' }} />Vedanagari
          </div>
        </div>

      </div>
    </section>
  );
}
